export default {
  methods: {
    goTo(path, condition = true) {
      if (condition) {
        this.$router.push(path).catch(() => { });
      }
    },
  },
};